import { UseMultipleChartsType } from '@ecosystem/export-utils';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export interface MultiLineChartExportType {
  multipleExportCallbacks: UseMultipleChartsType;
  setMultipleExportCallbacks: Dispatch<SetStateAction<UseMultipleChartsType>>;
  chartRefLoadedState: boolean[];
  setChartRefLoadedState: Dispatch<SetStateAction<boolean[]>>;
}

export const MultiChartExportContext = createContext<MultiLineChartExportType>({} as MultiLineChartExportType);

export const useMultiLineChartExport = (): MultiLineChartExportType =>
  useContext<MultiLineChartExportType>(MultiChartExportContext);
